///<reference path="../../../../build/typings/index.d.ts" />
//@TODO: Migrate this
namespace TotalContest {
    class Button {
        constructor(label, callback, cssClass?) {
            let template = `<button class="button ${cssClass || ''}" style="margin-right: 10px;">${label || ''}</button>`;

            let button = jQuery(template);
            button.on('click', callback);

            return button;
        }
    }

    class PointerSettings {
        constructor(args) {
            let template = `<h3>${args.title || ''}</h3><p>${args.body || ''}</p>`;

            return jQuery.extend(
                true,
                {
                    content: template,
                    position: {
                        edge: 'left',
                        align: 'left'
                    }
                },
                args
            );
        }
    }

    class Pointers {
        public pointers: any = jQuery();
        public context = 'global';
        public i18n = {
            done: 'Done',
            next: 'Next',
            previous: 'Previous',
        };
        public current: any = false;

        constructor(args) {
            if (args.context) {
                this.context = args.context;
            }

            if (args.i18n) {
                this.i18n = args.i18n;
            }

            if (args.items) {
                jQuery.each(
                    args.items,
                    (selector, args) => {
                        let instance = jQuery(selector)['pointer'](new PointerSettings(args)).data('wpPointer');

                        this.pointers.push(instance);
                    }
                );
            }
        }

        next() {
            this.open(this.current + 1);
        }

        previous() {
            this.open(this.current - 1);
        }

        start() {
            this.open(0);
        }

        open(index) {
            if (this.pointers[this.current]) {
                this.pointers[this.current].close();
            }

            if (this.pointers[index]) {
                this.current = parseInt(index);

                let instance = this.pointers.get(this.current);
                instance.open();

                let position = instance.element.offset().top - instance.element.outerHeight() - 100;
                let buttons = instance.content.find('.wp-pointer-buttons');

                buttons.find('.close').on('click', jQuery.proxy(this.dismiss, this));

                if (this.current !== 0) {
                    buttons.append(new Button(this.i18n.previous, jQuery.proxy(this.previous, this)));
                }

                if (this.current < this.pointers.length - 1) {
                    buttons.append(new Button(this.i18n.next, jQuery.proxy(this.next, this), 'button-primary'));
                }

                if (this.current === this.pointers.length - 1) {
                    buttons.append(new Button(this.i18n.done, jQuery.proxy(this.dismiss, this), 'button-primary'));
                }
            }
        }

        dismiss() {
            this.pointers[this.current].close();
            jQuery.get(window['ajaxurl'], {action: 'totalcontest_dismiss', type: 'pointer', object: this.context});
        }
    }


    jQuery(function ($) {

        if (window['totalcontestPointers']) {
            let pointers = new Pointers(window['totalcontestPointers']);
            pointers.start();
        }

    });
}